import {
  INSCRIBE_NAV_ITEMS,
  PUBLIC_NAV_ITEMS,
  type PublicNavItem,
} from "../shared/public-features";

export { INSCRIBE_NAV_ITEMS, PUBLIC_NAV_ITEMS };
export type { PublicNavItem };

function pathMatches(pathname: string, target: string) {
  return pathname === target || pathname.startsWith(`${target}/`);
}

export function publicNavItemIsActive(pathname: string, item: PublicNavItem) {
  if (item.excludeActivePrefixes?.some((prefix) => pathMatches(pathname, prefix))) {
    return false;
  }
  if (item.activePaths) {
    return item.activePaths.some((target) => pathMatches(pathname, target));
  }
  if (item.activePrefix) {
    return pathMatches(pathname, item.activePrefix)
      && !item.excludeActivePrefixes?.some((prefix) => pathMatches(pathname, prefix));
  }
  return item.end ? pathname === item.to : pathMatches(pathname, item.to);
}
